import { useState, useEffect, useCallback } from 'react';
import { checkServerHealth } from '../config/api';

export const useServerHealth = () => {
  const [isHealthy, setIsHealthy] = useState(true);
  const [lastCheck, setLastCheck] = useState(null);
  const [error, setError] = useState(null);

  const performHealthCheck = useCallback(async () => {
    try {
      const result = await checkServerHealth();
      setIsHealthy(result.healthy);
      setError(result.healthy ? null : result.error);
      setLastCheck(new Date());
      return result;
    } catch (err) {
      setIsHealthy(false);
      setError(err.message);
      setLastCheck(new Date());
      return { healthy: false, error: err.message };
    }
  }, []);

  useEffect(() => {
    // Initial health check
    performHealthCheck();

    // Set up periodic health checks
    const interval = setInterval(performHealthCheck, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, [performHealthCheck]);

  return {
    isHealthy,
    lastCheck,
    error,
    checkHealth: performHealthCheck
  };
};